import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { isThisSecond } from 'date-fns';
import { PdfThumbListComponent } from 'src/app/viewer';
import { BoardService } from 'src/shared/services/board.service';
import {User} from '../../../../../shared/models/user.class';
import {UserService} from '../../../../../shared/services/user/user.service';

@Component({
  selector: 'app-dialog-lookup-users-groups',
  templateUrl: './dialog-lookup-users-groups.component.html',
  styleUrls: ['./dialog-lookup-users-groups.component.scss']
})
export class DialogLookupUsersGroupsComponent implements OnInit {
  public loading: boolean;
  public originalUsers: User[];
  public users: User[];
  myArray: any[] = [];
  deleteUser: boolean;
  kanbanTitle: any;


  constructor(
    private user: UserService,
    public boardService: BoardService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogLookupUsersGroupsComponent>
  ) {}

  ngOnInit() {   
    this.deleteUser= false
    if (this.data){
      for(let i = 0; i< this.data.affect.length; i++){
        if(this.data.affect[i] == null){
          this.data.affect.splice(i, 1)
        }
      }
      this.data.affect.forEach((element) => {
        if (!this.myArray.includes(element)) {
          if(element !=null){
            this.myArray.push(element);
          }
        }
       });
    }
   
    this.initializeUsers();
    
  }

  ngOnChanges(){
    this.ngOnInit()
  }

  delete(user){
    this.boardService.removeAffect(this.data.kanbanid, this.data.columnid, this.data.itemid._id, this.data.itemid, user).subscribe()
    this.data.affect.splice(user, 1)
    this.myArray.splice(user, 1)
    this.ngOnInit()
  }

  onSelect(user: User) {
    this.myArray.push(user.completeName);
    this.ngOnInit()
    this.dialogRef.close({affect: this.myArray, mail:user.email})
  }

  public filter(str: string) {
    if (typeof str !== 'string') {
      return;
    }

    this.users = this.originalUsers.filter((us: User) => {
      return us.completeName.toLowerCase().indexOf(str.toLowerCase()) !== -1;
    });
  }

  private initializeUsers() {
    this.loading = true;

    this.user.loadAllUsers().then((res: User[]) => {
      this.loading = false;
      this.originalUsers = res;
      this.filter('');
    });
  }
}
